import $ from 'jquery';
import { createFocusTrap } from 'focus-trap';
import { closeModal as closeFacetsModal } from '../collection/facets-bar';
const SEARCH_DESKTOP_OPEN = '#js-search-desktop-open';
const SEARCH_DESKTOP = '#js-search-desktop';
const SEARCH_DESKTOP_INPUT = '#js-search-desktop-input';
const SEARCH_DESKTOP_CLOSE = '#js-search-desktop-close';
export const init = async function() {
    // hide search icon and show close icon
    $('.js-offcanvas-trigger[data-drawer-name="search"]').on('click', function() {
        $(this).toggleClass('hide');
        $('.js-search-hide[data-drawer-name="search"]').toggleClass('hide');
        $(this).attr('aria-expanded', 'true');
        if (window.nostojs) {
            window.nostojs((api)=>{
                api.loadRecommendations();
            });
        } else {
            console.warn('Nosto js not found');
        }
    });
    // handleCollectionNavPresence works in conjuction with Nosto react code for search
    // please refer to https://my.nosto.com/admin/shopify-5056125/search-code/editor
    // This is to remove the collection nav and the filters nav from the header-section group
    // of a collection page if a search q parameter is present in the url.
    const handleCollectionNavPresence = ()=>{
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const categories = $('.js-nosto-search-categories');
        const filters = $('.js-nosto-search-filter-nav');
        if (categories && filters) {
            if (params.has('q')) {
                categories.hide();
                filters.hide();
            } else {
                categories.show();
                filters.show();
            }
        }
    };
    handleCollectionNavPresence();
    const jqSearchDesktop = $(SEARCH_DESKTOP);
    const searchDesktopElement = jqSearchDesktop.get(0);
    if (searchDesktopElement) {
        const focusTrap = createFocusTrap(searchDesktopElement);
        // open desktop search
        $(SEARCH_DESKTOP_OPEN).on('click', function() {
            $(SEARCH_DESKTOP).slideDown();
            $(SEARCH_DESKTOP_OPEN).attr('aria-expanded', 'true');
            focusTrap === null || focusTrap === void 0 ? void 0 : focusTrap.activate();
            $(SEARCH_DESKTOP_INPUT).focus();
            closeFacetsModal();
            if (window.nostojs) {
                window.nostojs((api)=>{
                    api.loadRecommendations();
                });
            } else {
                console.warn('Nosto js not found');
            }
        });
        // close desktop search
        $(SEARCH_DESKTOP_CLOSE).on('click', function() {
            $(SEARCH_DESKTOP).slideUp();
            $(SEARCH_DESKTOP_OPEN).attr('aria-expanded', 'false');
            focusTrap === null || focusTrap === void 0 ? void 0 : focusTrap.deactivate();
        });
    }
};
